import * as React from 'react';
import type { SVGProps } from 'react';
export const SvgExclamationSolid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    style={{
      color: 'inherit',
      ...props.style,
    }}
  >
    <path
      d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07M9 5v6h2V5zm0 8v2h2v-2z"
      fill="currentColor"
    />
  </svg>
);
